/* eslint-disable import/no-default-export */
import {ThankYouPageController} from './ThankYouPageController';
import {controllerFactory} from '@wix/wixstores-client-storefront-sdk/dist/es/src/controller-factory/controllerFactory';

export default controllerFactory(ThankYouPageController);
